export enum EJRecordTypes {
  Coupon = 'Coupon',
  Promotion = 'Promotion',
  RewardAsTender = 'RewardAsTender',
  Reward = 'Reward',
  Product = 'Product',
  Tender = 'Tender',
  ReturnItem = 'ReturnItem',
  Indicator = 'Indicator',
  CustomerItemInfo = 'CustomerItemInfo',
  Refund = 'Refund',
  TaxExemption = 'TaxExemption',
  ItemFee = 'ItemFee',
  TransactionFee = 'TransactionFee',
  TenderEligibility = 'TenderEligibility',
  IssuedCoupon = 'IssuedCoupon',
}
